// TODO: how to be automatic and support any number?
export function getArabicOrdinalFemale(num) {
  const base = [
    "الأولى",
    "الثانية",
    "الثالثة",
    "الرابعة",
    "الخامسة",
    "السادسة",
    "السابعة",
    "الثامنة",
    "التاسعة",
    "العاشرة",
  ];

  const teens = [
    "الحادية عشرة",
    "الثانية عشرة",
    "الثالثة عشرة",
    "الرابعة عشرة",
    "الخامسة عشرة",
    "السادسة عشرة",
    "السابعة عشرة",
    "الثامنة عشرة",
    "التاسعة عشرة",
  ];

  const tens = {
    20: "العشرون",
    30: "الثلاثون",
    40: "الأربعون",
    50: "الخمسون",
    60: "الستون",
    70: "السبعون",
    80: "الثمانون",
    90: "التسعون",
  };

  if (num >= 1 && num <= 10) return base[num - 1];
  if (num >= 11 && num <= 19) return teens[num - 11];
  if (tens[num]) return tens[num];

  if (num > 20 && num < 100) {
    const unit = num % 10;
    const ten = num - unit;
    if (unit === 0) return tens[ten];
    return `${base[unit - 1]} و${tens[ten]}`;
  }

  return ""; // For now, only 1–99
}
